export default __webpack_public_path__ + "static/media/thumbsUp.9e90e5d1.png";